import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  SpText,
} from 'components/DesignKit';
import TransferCenter from 'imgs/transfers.svg';
import { navigationCardInventory } from 'appconstants/navigationCard';
import '../../styles/_navigationCard.scss';
import { lynxTenantDetailActions } from '../../store/actions';

type Props = {
  history: {
    push: Function,
    replace: Function,
  },
  selectedAccount: Object,
  fetchLynxTenantDetails: Function,
  lynxTenantDetails: Array,
};

const Inventory = (props: Props) => {
  const {
    history,
    selectedAccount,
    fetchLynxTenantDetails,
    lynxTenantDetails,
  } = props;

  const [filteredNavigationCardInventory, setFilteredNavigationCardInventory] = useState(navigationCardInventory);

  useEffect(() => {
    // Trigger fetching the tenant details when selectedAccount changes
    fetchLynxTenantDetails();
  }, [selectedAccount]);

  useEffect(() => {
    // Update filtered inventory based on updated lynxTenantDetails
    if (!lynxTenantDetails || lynxTenantDetails.length === 0) {
      setFilteredNavigationCardInventory(navigationCardInventory.filter(item => item.name !== 'Lynx Connect'));
    } else {
      setFilteredNavigationCardInventory(navigationCardInventory);
    }
  }, [lynxTenantDetails]);


  return (
    <>
      <div
        className="mx-auto mt-5"
        style={{ width: 1000, height: 'auto' }}
      >
        <div className="d-flex flex-column align-items-center justify-content-center mx-auto h-100">
          <img
            style={{ width: '350px' }}
            src={TransferCenter}
            alt="IMG"
          />
          <SpText fontSize="26px" fontWeight="600">INVENTORY</SpText>
          <SpText fontSize="18px" fontWeight="400">Track, manage, and organize your product stock in real time.</SpText>
        </div>
      </div>
      <div className="main_div">
        {filteredNavigationCardInventory.map((item, index) => (
          <div
            key={index}
            className="card"
            onClick={() => history.push(item.path)}
          >
            <div className="mt-2">
              <img src={item.svg} alt={item.name} />
              <p style={{ fontSize: '14px', fontWeight: '400' }} className="mt-2">{item.name}</p>
            </div>
          </div>
        ))}
      </div>
    </>

  );
};

const mapStateToProps = (state) => ({
  validator: state.loading.validator,
  submitting: state.loading.submitting,
  selectedAccount: state.account.selectedAccount,
  lynxTenantDetails: state.lynxTenantDetails.lynxTenantDetails,
});

const mapDispatchToProps = dispatch => ({
  fetchLynxTenantDetails: param => dispatch(lynxTenantDetailActions.fetchLynxTenantDetails({
    payload: param,
  })),
});


export default connect(mapStateToProps, mapDispatchToProps)(Inventory);
